import React from 'react';
import '../Footer/Footer.scss';

export const Footer = () => {
  return (
    <div className="footer">
      <p>
        {' '}
        Recipe<span> Finder</span> &copy; 2022 by Gulumser Cakmak all rights
        reserved
      </p>
    </div>
  );
};

export default Footer;
